import { Component, OnInit } from '@angular/core';
import { CalibrationClasses, CalificationClasses, TestClasses, IEquipment, Classes } from 'src/app/models/equipment.model';
import { BehaviorSubject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
  animations: [
    trigger('slide', [
      state('opened', style({ width: '20em' })),
      state('closed', style({ width: '0' })),
      transition('opened <=> closed', animate('150ms ease-in'))
    ])
  ]
})
export class ServicesComponent implements OnInit {
  equipment: IEquipment[];
  selectedClass: Classes;
  selectedSubClass: any;
  filteredEquipment: BehaviorSubject<IEquipment[][]>;
  showMenu = false;

  constructor(private title: Title) { }

  get calibrationClasses() { return CalibrationClasses; }
  get calificationClasses() { return CalificationClasses; }
  get testClasses() { return TestClasses; }
  get classes() { return Classes; }

  private getEquipment() {
    const equipmentByClass = this.equipment.filter(equipment => equipment.class === this.selectedClass);
    const equipmentGroups = [];
    if (this.selectedSubClass) {
      equipmentGroups.push(equipmentByClass.filter((equipment) =>
        equipment.subClass === this.selectedSubClass));
    } else {
      switch (this.selectedClass) {
        case Classes.CALIBRATION:
          for (const sub of Object.keys(CalibrationClasses)) {
            equipmentGroups.push(this.equipment.filter(equipment => equipment.subClass === CalibrationClasses[sub]));
          }
          break;
        case Classes.CALIFICATION:
          for (const sub of Object.keys(CalificationClasses)) {
            equipmentGroups.push(this.equipment.filter(equipment => equipment.subClass === CalificationClasses[sub]));
          }
          break;
        case Classes.TEST:
          for (const sub of Object.keys(TestClasses)) {
            equipmentGroups.push(this.equipment.filter(equipment => equipment.subClass === TestClasses[sub]));
          }
          break;
      }
    }

    return equipmentGroups;
  }

  ngOnInit() {
    this.title.setTitle('Servicios - CCCISA');
    this.selectedClass = Classes.CALIBRATION;
    this.equipment = [
      // Temperature
      {
        name: 'Termómetros líquidos en vidrio',
        imageUrl: '/assets/img/equipment/temperatura/termo_vidrio.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.TEMPERATURE
      },
      {
        name: 'Termómetros Bimetálicos',
        imageUrl: '/assets/img/equipment/temperatura/termo_bimetalico.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.TEMPERATURE
      },
      {
        name: 'Termopares Tipo K,J,T,N,E,PT-100, Etc.',
        imageUrl: '/assets/img/equipment/temperatura/termopares.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.TEMPERATURE
      },
      {
        name: 'Graficadores de temperatura',
        imageUrl: '/assets/img/equipment/temperatura/graficador.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.TEMPERATURE
      },
      {
        name: 'Datalogger de temperatura',
        imageUrl: '/assets/img/equipment/temperatura/logger.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.TEMPERATURE
      },
      {
        name: 'Termómetros Infrarrojos (Pirómetros)',
        imageUrl: '/assets/img/equipment/temperatura/infra.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.TEMPERATURE
      },
      // Presion
      {
        name: 'Manómetros',
        imageUrl: '/assets/img/equipment/presion/manometro.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.PRESION
      },
      {
        name: 'Vacuómetros',
        imageUrl: '/assets/img/equipment/presion/vacuometro.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.PRESION
      },
      {
        name: 'Manovacuómetros',
        imageUrl: '/assets/img/equipment/presion/manovacuometros.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.PRESION
      },
      {
        name: 'Manómetros diferenciales',
        imageUrl: '/assets/img/equipment/presion/mano_dif.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.PRESION
      },
      {
        name: 'Indicadores de presión',
        imageUrl: '/assets/img/equipment/presion/indicadores.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.PRESION
      },
      {
        name: 'Registradores de presión',
        imageUrl: '/assets/img/equipment/presion/registrador.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.PRESION
      },
      {
        name: 'Transmisores de presión',
        imageUrl: '/assets/img/equipment/presion/transmisor.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.PRESION
      },
      {
        name: 'Baumanómetro',
        imageUrl: '/assets/img/equipment/presion/baumanometro.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.PRESION
      },
      // Masa
      {
        name: 'Balanzas analíticas',
        imageUrl: '/assets/img/equipment/masa/analitica.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.MASS
      },
      {
        name: 'Balanzas de precisón',
        imageUrl: '/assets/img/equipment/masa/prec.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.MASS
      },
      {
        name: 'Básculas de plataforma',
        imageUrl: '/assets/img/equipment/masa/bascula.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.MASS
      },
      {
        name: 'Celdas de carga',
        imageUrl: '/assets/img/equipment/masa/celda.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.MASS
      },
      {
        name: 'Tolvas',
        imageUrl: '/assets/img/equipment/masa/tolva.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.MASS
      },
      {
        name: 'Higrómetros',
        imageUrl: '/assets/img/equipment/humedad/higrometro.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.HUMIDITY
      },
      {
        name: 'Graficadores de humedad',
        imageUrl: '/assets/img/equipment/humedad/graficador.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.HUMIDITY
      },
      {
        name: 'Registradores de humedad',
        imageUrl: '/assets/img/equipment/humedad/registradores.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.HUMIDITY
      },
      {
        name: 'Datalogger de humedad',
        imageUrl: '/assets/img/equipment/humedad/datalogger.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.HUMIDITY
      },
      {
        name: 'Calibradores',
        imageUrl: '/assets/img/equipment/dimensional/calibrador.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.DIMENSION
      },
      {
        name: 'Micrómetros de exteriores',
        imageUrl: '/assets/img/equipment/dimensional/micro-ext.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.DIMENSION
      },
      {
        name: 'Micrómetros de interiores',
        imageUrl: '/assets/img/equipment/dimensional/micro-int.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.DIMENSION
      },
      {
        name: 'Micrómetros de profundidad',
        imageUrl: '/assets/img/equipment/dimensional/micro-prof.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.DIMENSION
      },
      {
        name: 'Indicadores',
        imageUrl: '/assets/img/equipment/dimensional/indicadores.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.DIMENSION
      },
      {
        name: 'Medidores de alturas',
        imageUrl: '/assets/img/equipment/dimensional/medidores_alturas.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.DIMENSION
      },
      {
        name: 'Medidores de espesores',
        imageUrl: '/assets/img/equipment/dimensional/medidores_espesores.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.DIMENSION
      },
      {
        name: 'Comparadores ópticos',
        imageUrl: '/assets/img/equipment/dimensional/comparadores.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.DIMENSION
      },
      {
        name: 'Pipetas de pistón',
        imageUrl: '/assets/img/equipment/volumen/pipeta_presion.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.VOLUME
      },
      {
        name: 'Pipetas',
        imageUrl: '/assets/img/equipment/volumen/pipeta.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.VOLUME
      },
      {
        name: 'Bureta',
        imageUrl: '/assets/img/equipment/volumen/bureta.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.VOLUME
      },
      {
        name: 'Dispensadoras',
        imageUrl: '/assets/img/equipment/volumen/dispensadoras.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.VOLUME
      },
      {
        name: 'Equipos multicanal',
        imageUrl: '/assets/img/equipment/volumen/pipeta-multicanal.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.VOLUME
      },
      {
        name: 'Matraz para entregar / contener',
        imageUrl: '/assets/img/equipment/volumen/matraz.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.VOLUME
      },
      {
        name: 'Probeta para entregar y contener',
        imageUrl: '/assets/img/equipment/volumen/probeta.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.VOLUME
      },
      {
        name: 'Recipientes especiales para contener',
        imageUrl: '/assets/img/equipment/volumen/recipientes.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.VOLUME
      },
      {
        name: 'Refractómetro digital',
        imageUrl: '/assets/img/equipment/optica/refractometro.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.OPTICS
      },      
      {
        name: 'Refractómetro de mano',
        imageUrl: '/assets/img/equipment/optica/refractometro2.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.OPTICS
      },        
      {
        name: 'Refractómetro de multilongitud de onda',
        imageUrl: '/assets/img/equipment/optica/refractometro3.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.OPTICS
      },    
      {
        name: 'Densímetro',
        imageUrl: '/assets/img/equipment/densidad/densimetro1.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.DENSITY
      },
      {
        name: 'Densímetros',
        imageUrl: '/assets/img/equipment/densidad/densimetro2.png',
        class: Classes.CALIBRATION,
        subClass: CalibrationClasses.DENSITY
      },      {
        name: 'Incubadora',
        imageUrl: '/assets/img/equipment/calificacion-equipos/incubator.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EQUIPMENT
      },
      {
        name: 'Estufa',
        imageUrl: '/assets/img/equipment/calificacion-equipos/estufa.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EQUIPMENT
      },
      {
        name: 'Refrigerador, congelador & ultracongelador',
        imageUrl: '/assets/img/equipment/calificacion-equipos/ultracongelador.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EQUIPMENT
      },
      {
        name: 'Autoclave',
        imageUrl: '/assets/img/equipment/calificacion-equipos/autoclave.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EQUIPMENT
      },
      {
        name: 'Habitaciones, recintos & almacenes',
        imageUrl: '/assets/img/equipment/calificacion-equipos/habitaciones.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EQUIPMENT
      },
      {
        name: 'Baño maría',
        imageUrl: '/assets/img/equipment/calificacion-equipos/maria.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EQUIPMENT
      },
      {
        name: 'Horno de pozo seco para calibración',
        imageUrl: '/assets/img/equipment/calificacion-equipos/horno.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EQUIPMENT
      },
      {
        name: 'Cámara de envejecimiento acelerado o cámara salina',
        imageUrl: '/assets/img/equipment/calificacion-equipos/camara_env.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EQUIPMENT
      },
      {
        name: 'Cámara de tratamiento térmico, horno, mufla & túneles',
        imageUrl: '/assets/img/equipment/calificacion-equipos/camara_trat.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EQUIPMENT
      },
      {
        name: 'Medidor de PH',
        imageUrl: '/assets/img/equipment/calificacion-eimas/medidor_ph.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EIMAS
      },
      {
        name: 'Medidor de conductividad',
        imageUrl: '/assets/img/equipment/calificacion-eimas/medidor_conductividad.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EIMAS
      },
      {
        name: 'Refractometros',
        imageUrl: '/assets/img/equipment/calificacion-eimas/refrac.png',
        class: Classes.CALIFICATION,
        subClass: CalificationClasses.EIMAS
      },
      {
        name: 'Válvulas de relevo de presión',
        imageUrl: '/assets/img/equipment/metal-mecanica/valv_relev_.png',
        class: Classes.TEST,
        subClass: TestClasses.MECHANICS
      },
      {
        name: 'Seguridad, Seguridad-Alivio y Alivio NOM-093-SCFI',
        imageUrl: '/assets/img/equipment/metal-mecanica/valv_relev_1.png',
        class: Classes.TEST,
        subClass: TestClasses.MECHANICS
      },
      {
        name: 'Punto de apertura y cierre',
        imageUrl: '/assets/img/equipment/metal-mecanica/valv_relev_2.png',
        class: Classes.TEST,
        subClass: TestClasses.MECHANICS
      },
      {
        name: 'Prueba neumática',
        imageUrl: '/assets/img/equipment/metal-mecanica/valv_relev_.png',
        class: Classes.TEST,
        subClass: TestClasses.MECHANICS
      },
      {
        name: 'Prueba de hermeticidad o sello',
        imageUrl: '/assets/img/equipment/metal-mecanica/valv_relev_1.png',
        class: Classes.TEST,
        subClass: TestClasses.MECHANICS
      }
    ];
    this.filteredEquipment = new BehaviorSubject<IEquipment[][]>(this.getEquipment());
  }

  selectSubclass(subClass: any, selectedClass: Classes) {
    console.log('selectsubclass');
    this.selectedClass = selectedClass;
    this.selectedSubClass = subClass;
    this.filteredEquipment.next(this.getEquipment());
    this.showMenu = !this.showMenu;
  }

  selectClass(selectedClass: Classes) {
    this.selectedClass = selectedClass;
    this.selectedSubClass = null;
    this.filteredEquipment.next(this.getEquipment());
    this.showMenu = !this.showMenu;
  }
}

